import React from 'react';
import { StyledRadio } from 'styles/components/Radio';

const Radio = ({ value, checked }) => (
  <StyledRadio color='primary' value={value} checked={checked} />
);

export default Radio;
